{
	"backLinkTitle": "Wróć do: Zarządzaj deklaracjami"
}
